// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"277":"87157609","970":"bf80a6f8"}[chunkId] + ".chunk.css";
};